export const MIME_TYPES = {
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV: 'text/csv',
  BIN: 'application/octet-stream',
  ZIP: 'application/zip',
  BMU: 'application/octet-stream',
} as const;
